<p>
  user-pharmacy works!
</p>
